// import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
// import logger from 'redux-logger';


// // import preferenceReducer from './reducers/preferenceSlice';
// import { preferenceSlice } from '@monorepo-web/logic-extrato';
// import resumoCartReducer from './reducers/resumoCartSlice';
// import perfHistReducer from './reducers/perfHistSlice';
// import posConReducer from './reducers/posConSlice';
// import cartExpReducer from './reducers/cartExpSlice';
// import fluxoAtivosReducer from './reducers/fluxoAtivosSlice';
// import fluxoCaixaReducer from './reducers/fluxoCaixaSlice';
// import estatsReducer from './reducers/estatsSlice';
// import loadMinimizedReducer from './reducers/loadMinimizedSlice';
// import capaPdfReducer from './reducers/capaPdfSlice';
// import { listenerMiddleware } from './listenerMiddleware';

// export const store = configureStore({
//   reducer: {
//     // preference: preferenceReducer,
//     preference: preferenceSlice.reducer,
//     resumoCart: resumoCartReducer,
//     perfHist: perfHistReducer,
//     posCon: posConReducer,
//     cartExp: cartExpReducer,
//     fluxoAtivos: fluxoAtivosReducer,
//     fluxoCaixa: fluxoCaixaReducer,
//     estats: estatsReducer,
//     loadMinimized: loadMinimizedReducer,
//   },
//   middleware: (getDefaultMiddleware) => {
//     const defaultMiddleware = getDefaultMiddleware();
//     if(process.env.NODE_ENV === 'development'){
//       // defaultMiddleware.unshift(logger);
//     }
//     defaultMiddleware.unshift(listenerMiddleware.middleware);
//     return defaultMiddleware;
//   },
// });

// export type AppDispatch = typeof store.dispatch;
// export type RootState = ReturnType<typeof store.getState>;
// export type AppThunk<ReturnType = void> = ThunkAction<
//   ReturnType,
//   RootState,
//   unknown,
//   Action<string>
// >;





import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
// import logger from 'redux-logger';
import {
  listenerMiddleware,
  preferenceSlice,
  resumoCartSlice,
  perfHistSlice,
  posConSlice,
  cartExpSlice,
  fluxoAtivosSlice,
  fluxoCaixaSlice,
  estatsSlice,
  loadMinimizedSlice,
  capaPdfSlice,
} from '@monorepo-web/logic-extrato';

export const store = configureStore({
  reducer: {
    preference: preferenceSlice.reducer,
    resumoCart: resumoCartSlice.reducer,
    perfHist: perfHistSlice.reducer,
    posCon: posConSlice.reducer,
    cartExp: cartExpSlice.reducer,
    fluxoAtivos: fluxoAtivosSlice.reducer,
    fluxoCaixa: fluxoCaixaSlice.reducer,
    estats: estatsSlice.reducer,
    loadMinimized: loadMinimizedSlice.reducer,
    capaPDF: capaPdfSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    const defaultMiddleware = getDefaultMiddleware();
    if(process.env.NODE_ENV === 'development'){
      // defaultMiddleware.unshift(logger);
    }
    defaultMiddleware.unshift(listenerMiddleware.middleware);
    return defaultMiddleware;
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
